var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"font-weight-bold"},[_c('i',{class:` ${_vm.icon} mr-2 c-orange fs-18`}),_vm._v(_vm._s(_vm.label))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.value)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }